import { ArrowLeft } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

/**
 * Not-found state for the client media-unit detail route. Renders no media-unit
 * section cards and offers a typed link back to the offer view. Shown when the
 * client detail endpoint returns 404 (no-permission / not-in-offer / missing).
 */
export function ClientUnitNotFound({ offerId }: { offerId: string }) {
  const { t } = useTranslation('inventory');
  return (
    <div
      data-testid="client-unit-not-found"
      className="flex h-screen flex-col items-center justify-center gap-4"
    >
      <p className="text-sm text-muted-foreground">{t('detail.clientDetail.notFound')}</p>
      <Link
        to="/offers/$offerId/client"
        params={{ offerId }}
        className="inline-flex items-center gap-1.5 text-[13px] text-muted-foreground transition-colors hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4" />
        {t('detail.clientDetail.backToOffer')}
      </Link>
    </div>
  );
}
